module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/start-tour/start-tour.component.scss
// module id = ./src/app/start-tour/start-tour.component.scss
// module chunks = main